module.exports = __webpack_public_path__ + "static/media/Logo.fa22158f.png";